import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@Components/Loader';

function SearchProgressModalContent(props) {
  const { progressPercentage, singleDatabase, currentDbName } = props;

  return (
    <div className="search-progress-modal__content">
      <Loader className="search-progress-modal__content_loader" startProgress={progressPercentage} />
      <div className="search-progress-modal__content_text u-els-font-size-h5">
        <div>{`Now searching in ${singleDatabase ? currentDbName : 'all databases'}`}</div>
      </div>
    </div>
  );
}

SearchProgressModalContent.propTypes = {
  singleDatabase: PropTypes.bool,
  progressPercentage: PropTypes.number,
  currentDbName: PropTypes.string,
};

export default SearchProgressModalContent;
